<div class="col-lg-12">
  <div class="formcontainer">
    <pre>Registrera nytt möte</pre>
    <form [formGroup]="registermeetingform" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-3">
          <label>
            Datum
          </label>
          <input [required]=true id="meetingDate" type="text" class="form-control form-control-sm" mask="0000-00-00" formControlName="meetingDate">
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <label>
            Rubrik
          </label>
          <input id="issue" type="text" class="form-control form-control-sm" maxlength="30" formControlName="issue">
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <label>
            Notering
          </label>
          <input id="comment" type="text" class="form-control form-control-sm" formControlName="comment">
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <label>
            Mötestyp
          </label>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio" class="form-check-input" name="meetingTypeId" value="0" formControlName="meetingTypeId">Ordinarie
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio" class="form-check-input" name="meetingTypeId" value="1" formControlName="meetingTypeId">Sommarmöte
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio" class="form-check-input" name="meetingTypeId" value="2" formControlName="meetingTypeId">Övrigt
            </label>
          </div>
        </div>
      </div>
    </form>
    <button (click)="save()">Spara</button>
  </div>
</div>